// extracted by mini-css-extract-plugin
export default {"footer":"footer__DGBa9","icons":"icons__mdufs","icon":"icon__I-pew","link":"link__81icT"};